import { BrandMark } from "./BrandMark";
import { NavIcon, type NavIconKind } from "./NavIcon";
import type { Route } from "../routing";

interface NavEntry {
  id: Route | "billing" | "settings";
  label: string;
  icon: NavIconKind;
  disabled?: boolean;
}

const NAV: NavEntry[] = [
  { id: "dashboard", label: "Dashboard", icon: "grid" },
  { id: "subscriptions", label: "Subscriptions", icon: "stack" },
  { id: "catalog", label: "Catalog", icon: "compass" },
  { id: "users", label: "Users & Seats", icon: "users" },
  { id: "billing", label: "Billing & IP", icon: "doc", disabled: true },
  { id: "settings", label: "Settings", icon: "gear", disabled: true },
];

interface Props {
  route: Route;
  partnerName: string;
  onNav: (route: Route) => void;
  onSwitchPartner: () => void;
}

export function Sidebar({ route, partnerName, onNav, onSwitchPartner }: Props) {
  return (
    <aside className="bbc-sidebar">
      <div className="bbc-brand">
        <BrandMark size={22} />
        <div className="bbc-brand-sub">Business Central</div>
      </div>

      <div className="bbc-partner">
        <div className="bbc-partner-label">Partner workspace</div>
        <button
          className="bbc-partner-switch"
          type="button"
          onClick={onSwitchPartner}
        >
          <span>{partnerName}</span>
          <svg width="10" height="10" viewBox="0 0 10 10">
            <path
              d="M2 4l3 3 3-3"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <nav className="bbc-nav">
        {NAV.map((n) => (
          <button
            key={n.id}
            type="button"
            className={`bbc-nav-item ${
              !n.disabled && route === n.id ? "is-active" : ""
            } ${n.disabled ? "is-disabled" : ""}`}
            disabled={n.disabled}
            onClick={() => !n.disabled && onNav(n.id as Route)}
          >
            <NavIcon kind={n.icon} />
            <span>{n.label}</span>
            {n.disabled && <em className="bbc-soon">soon</em>}
          </button>
        ))}
      </nav>

      <div className="bbc-sidebar-foot">
        <div className="bbc-foot-card">
          <div className="bbc-foot-title">IP attestation due</div>
          <div className="bbc-foot-body">Q2 usage report — by Jun 30</div>
          <button className="bbc-foot-btn" type="button">
            Open report →
          </button>
        </div>
      </div>
    </aside>
  );
}
